// © Microsoft Corporation. All rights reserved.

import { DesignSystem } from "@microsoft/fast-components-styles-msft";

export const ContentSocialBarSuperAppStyles = (config: DesignSystem) => ({
    contentSocialBarSuperAppContainer: {
        padding: "72px 16px 0",
        margin: "5px 0 0"
    },

    contentReactionPopoversSuperAppContainer: {
        left: "0"
    }
});